import type { JobTriggerKey } from "components/Socials/JobTriggerPanel"

import JobTriggerActivity from "./JobTriggerActivity"

export type JobTriggerActivityStatus = "queued" | "conflict" | "error"

export interface JobTriggerActivityEntry {
  at: string
  id: string
  job: JobTriggerKey
  message: string | null
  status: JobTriggerActivityStatus
  user: string
}

export interface Props {
  activity: JobTriggerActivityEntry[]
}

export interface ComponentProps extends Props {}

export default JobTriggerActivity
